import type { EventStep } from '~/types/interfaces'

interface EventSystemState {
  isProcessing: boolean
  lastProcessedSteps: EventStep[]
  // #791 MR6: task step polling 中の server 由来ラベル (儀式 UX)。
  // 未 polling / polling 終了時は '' (空)。dialog 側 (CrystallizeDialog.vue) が
  // 参照して "魔導書を確認中…" 等を表示する。Fable Round 5 Q18: server ceremony_label
  // を truth に。
  taskLabel: string
  // #791 MR6: 現在進行中の polling を cleanup するための AbortController。
  // Fable Round 5 見落とし 1: ページ離脱 = task 放棄 (localStorage に taskId を残さない)。
  // Route change や pinia store reset の際に abort() → useEventSystem が gracefully 終了する。
  _abortController: AbortController | null
}

export const useEventSystemStore = defineStore('eventSystem', {
  state: (): EventSystemState => ({
    isProcessing: false,
    lastProcessedSteps: [],
    taskLabel: '',
    _abortController: null,
  }),
  actions: {
    startProcessing() {
      this.isProcessing = true
    },
    finishProcessing(steps: EventStep[]) {
      this.lastProcessedSteps = steps
      this.isProcessing = false
      this.taskLabel = ''
      this._abortController = null
    },
    setTaskLabel(label: string) {
      this.taskLabel = label
    },
    clearTaskLabel() {
      this.taskLabel = ''
    },
    setAbortController(controller: AbortController) {
      // 既存の polling があれば abort (concurrent trigger による orphan polling 防止)。
      this._abortController?.abort()
      this._abortController = controller
    },
    abortActivePolling() {
      // Router beforeEach / onBeforeUnmount 等から呼ぶ。実行中の task step polling を止める。
      // task 自体 (SFN execution) は継続実行されるが、client は結果を受け取らない
      // (Fable Round 5 見落とし 1)。
      this._abortController?.abort()
      this._abortController = null
      this.taskLabel = ''
    },
    reset() {
      this.abortActivePolling()
      this.isProcessing = false
      this.lastProcessedSteps = []
    },
  },
})
